export default __webpack_public_path__ + "static/media/Chershire_Cat.24ee16b9.jpeg";